// extracted by mini-css-extract-plugin
export default {"otpInputError":"verifyAccount_otpInputError__16p1m","inputOtpStyle":"verifyAccount_inputOtpStyle__Zs0N9","g-recaptcha":"verifyAccount_g-recaptcha__n0rTD"};